var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-1"},[_c('div',{staticClass:"justify-space-between d-flex border-bottom black--text pa-1 item"},[_c('span',[_vm._v(" "+_vm._s(_vm.left)+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.right)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }